export const VODAFONE_PARTNER = 'VFSPAIN';
